var clock = "https://shopfront-cdn.tekoapis.com/static/c1ea89899161ab54.svg";

export { clock as default };
